import { render, staticRenderFns } from "./ShopPc.vue?vue&type=template&id=a6a08b62&scoped=true&"
import script from "./ShopPc.vue?vue&type=script&lang=js&"
export * from "./ShopPc.vue?vue&type=script&lang=js&"
import style0 from "./ShopPc.vue?vue&type=style&index=0&id=a6a08b62&lang=scss&rel=stylesheet%2Fscss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6a08b62",
  null
  
)

export default component.exports